import React from 'react'
import styles from './group.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import TimesIcon from 'react-icons/lib/fa/times-circle'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const Group = ({ classes, title, onDelete, className, mis, editable }) => (
  <div className={classNames(classes.group, className)}>
    {title} {mis && <span className={classes.mis}>MIS</span>}
    {editable && (
      <TimesIcon
        onClick={() =>
          openConfirmationDialog({
            bodyText: `Are you sure you want to remove pupil from ${title} ?`,
            confirmText: 'Remove from group',
            action: onDelete
          })
        }
        className={classes.icon}
      />
    )}
  </div>
)

export default injectSheet(styles)(Group)
